<script>
    import { notificate } from "../../../services/notification.js";
    import { translateErrorMessages } from "../../../services/api.svelte.js";
    import { form as svForm, field } from "svelte-forms";
    import { required } from "svelte-forms/validators";
    import campaignService from "./service.js";
    import { removeTags } from "../../../js/utils.js";
    import { format } from "svelte-i18n";

    let { campaign, onsave, oncancel } = $props();

    let formDataPromise = $state();
    let formData = $state({});
    let formIsSubmitted = $state(false);
    let APIerror = $state(null);
    let formApiErrors = $state({});
    let showformApiErrors = $state(false);
    let is_editing = $state(false);

    const nameField = field("name", "", [required()]);
    const descriptionField = field("description", "");
    const myForm = svForm(nameField);

    if (!campaign) {
        formDataPromise = Promise.resolve((formData = {}));
    } else {
        is_editing = true;
        formData = {
            name: campaign.name,
            id: campaign.id,
            description: campaign.description,
        };
        nameField.set(formData.name);
        descriptionField.set(formData.description);
        formDataPromise = Promise.resolve(formData);
    }

    function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid) ||
            formApiErrors[field]
        );
    }

    async function handleSubmit(event) {
        if (event) event.preventDefault();

        formIsSubmitted = true;
        formApiErrors = {};

        await nameField.validate();

        if ($myForm.hasError("name.required")) {
            notificate("422");
            return false;
        }

        formData = {
            name: $nameField.value,
            description: $descriptionField.value,
        };

        for (let [k, v] of Object.entries(formData)) {
            if (typeof v == "string") formData[k] = removeTags(v);
        }

        if (is_editing) formData.id = campaign.id;

        campaignService
            .save(formData, [], {}, !is_editing)
            .then((savedCampaign) => {
                if (onsave) onsave(savedCampaign);
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                return true;
            })
            .catch((errors) => {
                if (typeof errors.detail == "string") {
                    APIerror = translateErrorMessages(
                        errors.detail,
                        "campañas de phishing",
                    );
                } else {
                    showformApiErrors = true;
                    APIerror = errors;
                }
                return false;
            });

        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }

    function handleCancel() {
        formIsSubmitted = false;
        if (oncancel) oncancel();
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") handleCancel();
    };
</script>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card mb-0">
        <div class="card-body">
            {#await formDataPromise then formDataUnused}
                <div class="mb-3">
                    <label for="campaignName"
                        >{$format("phishing.campaign.name")}<span
                            class="text-danger">*</span
                        ></label
                    >
                    <input
                        type="text"
                        class="form-control"
                        id="campaignName"
                        name="name"
                        placeholder={$format("phishing.campaign.name")}
                        bind:value={$nameField.value}
                        onchange={async () => await nameField.validate()}
                        class:is-invalid={shouldShowFieldError($nameField)}
                    />
                    {#if APIerror && !is_editing}
                        <div class="mt-3 text-danger" style="font-size: 80%;">
                            {APIerror}
                        </div>
                    {/if}
                    {#if shouldShowFieldError($nameField)}
                        {#if $myForm.hasError("name.required")}
                            <div class="invalid-feedback">
                                {$format("required")}
                            </div>
                        {/if}
                    {/if}
                </div>

                <div class="mb-3">
                    <label for="campaignDescription"
                        >{$format("phishing.campaign.description")}</label
                    >
                    <textarea
                        class="form-control"
                        id="campaignDescription"
                        name="description"
                        placeholder={$format("phishing.campaign.description")}
                        bind:value={$descriptionField.value}
                        rows="3"></textarea>
                </div>
            {/await}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary"
                >{$format("buttons.save")}</button
            >
            <button class="btn btn-default" type="button" onclick={handleCancel}
                >{$format("buttons.cancel")}</button
            >
        </div>
        {#await formDataPromise}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
        {/await}
    </div>
</form>

<style>
    .alert.alert-warning {
        color: #856404;
        background-color: #fff3cd;
    }
</style>
